import React from "react";

// Package Import

import {
  Typography,
  Box,
  useTheme,
  Button,
  Grid,
  Paper,
  Chip,
  Stack,
  TableContainer,
  TableHead,
  Table,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import { format } from "date-fns";
import { makeStyles } from "@mui/styles";

// User Import

import {
  BatchIcon1,
  ProvinceIcon2,
  TempratureIcon,
  ExpiredDosesIcon,
  WastedDosesIcon,
  QuantityTransferredIcon,
  RedCircle,
  TotalQuantityIcon,
  ArrowIcon,
  RectangleClinic,
  RectangleDistrict,
  RectangleMinistry,
  RectangleProvince,
} from "../../Svg";
import { useLocation, useNavigate } from "react-router-dom";
import {
  commonRoutes,
  ministryRoutes,
  RoutesUrls,
} from "../../../src/Services/Routes/APP";

// Component

const BatchDetails = ({ batch }) => {
  const theme = useTheme();
  const { state } = useLocation();
  const navigate = useNavigate();

  const transactionTable = () => {
    navigate(RoutesUrls?.ministryAdmin + commonRoutes?.transactions, {
      state: {
        vaccines: state.vaccines,
      },
    });
  };

  const useStyles = makeStyles({
    list: {
      overflowY: "scroll",
      margin: 0,
      padding: 0,
      listStyle: "none",
      height: "532px",
      "&::-webkit-scrollbar": {
        width: "0.3em",
        borderRadius: "50%",
      },
      "&::-webkit-scrollbar-track": {
        boxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
        webkitBoxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "#ebebeb",
        outline: "1px solid white",
      },
    },
  });

  const rows = [
    {
      senderName: "QueensLand",
      receiverName: "Capital Hill",
      transferDate: "22-7-2022",
      batchQuantity: 5000,
      storageTemprature: "10 Degree",
      expiry: "03-09-2022",
    },
    {
      senderName: "QueensLand",
      receiverName: "Capital Hill",
      transferDate: "22-7-2022",
      batchQuantity: 5000,
      storageTemprature: "10 Degree",
      expiry: "03-09-2022",
    },
    {
      senderName: "QueensLand",
      receiverName: "Capital Hill",
      transferDate: "22-7-2022",
      batchQuantity: 5000,
      storageTemprature: "10 Degree",
      expiry: "03-09-2022",
    },
  ];

  const headings = [
    "Batch#",
    "Sender",
    "Receiver",
    "Quantity",
    "Type",
    "Transaction Type",
    "Expiry Date",
    "Storage Temprature",
    "Transaction Date",
  ];
  const transactions = [
    {
      senderRole: "ministry",
      receiverRole: "province",
      batchNo: "12345",
      senderName: "QueensLand",
      receiverName: "Capital Hill",
      quantity: "5000",
      type: "Vaccine",
      transactionType: "Transfered",
      expiry: "04-09-2022",
      storageTemprature: "10 Degree",
      transferDate: "02-07-2022",
    },
    {
      senderRole: "province",
      receiverRole: "district",
      batchNo: "12345",
      senderName: "QueensLand",
      receiverName: "Capital Hill",
      quantity: "5000",
      type: "Vaccine",
      transactionType: "Expired",
      expiry: "04-09-2022",
      storageTemprature: "10 Degree",
      transferDate: "02-07-2022",
    },
    {
      senderRole: "district",
      receiverRole: "clinic",
      batchNo: "12345",
      senderName: "QueensLand",
      receiverName: "Capital Hill",
      quantity: "5000",
      type: "Vaccine",
      transactionType: "Used",
      expiry: "04-09-2022",
      storageTemprature: "10 Degree",
      transferDate: "02-07-2022",
    },
    {
      senderRole: "clinic",
      receiverRole: "district",
      batchNo: "12345",
      senderName: "QueensLand",
      receiverName: "Capital Hill",
      quantity: "5000",
      type: "Vaccine",
      transactionType: "Damaged",
      expiry: "04-09-2022",
      storageTemprature: "10 Degree",
      transferDate: "02-07-2022",
    },
    {
      senderRole: "province",
      receiverRole: "district",
      batchNo: "12345",
      senderName: "QueensLand",
      receiverName: "Capital Hill",
      quantity: "5000",
      type: "Vaccine",
      transactionType: "Transfered",
      expiry: "04-09-2022",
      storageTemprature: "10 Degree",
      transferDate: "02-07-2022",
    },
  ];
  const classes = useStyles();

  return (
    <Box>
      <Grid container spacing={2} display={"flex"} alignItems={"stretch"}>
        <Grid item spacing={2} xs={12} sm={12} md={6} lg={6} xl={6}>
          <Paper sx={{ height: "100%" }}>
            <Box padding={2}>
              <Typography variant="h6" component="div">
                General Information
              </Typography>
              <Typography sx={{ mb: 1.5 }} color="text.secondary">
                {"Batch# " + state?.vaccines?.reference_number}
              </Typography>
              {/* 1 ROW */}
              <Grid
                container
                display={"flex"}
                justifyContent={"space-between"}
                alignItems={"center"}
                sx={{ mb: 1.5 }}
              >
                <Box display={"flex"} alignItems={"center"}>
                  <Box
                    height={"60px"}
                    width={"60px"}
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"center"}
                    sx={{
                      backgroundColor: `${theme.palette.secondary.dark}`,
                      borderRadius: 1.5,
                    }}
                  >
                    <TotalQuantityIcon />
                  </Box>
                  <Box>
                    <Typography
                      ml={2}
                      sx={{
                        textAlign: "left",
                      }}
                    >
                      Total Quantity{" "}
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ paddingTop: 1.2 }}>
                  <Chip
                    label={state?.vaccines?.size || "NA"}
                    sx={{
                      minWidth: "70px",
                      color: "blue",
                      borderRadius: 1,
                    }}
                  />
                </Box>
              </Grid>
              {/* 2nd Row */}
              <Grid
                container
                display={"flex"}
                justifyContent={"space-between"}
                alignItems={"center"}
                sx={{ mb: 1.5 }}
              >
                <Box display={"flex"} alignItems={"center"}>
                  <Box
                    height={"60px"}
                    width={"60px"}
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"center"}
                    sx={{
                      backgroundColor: `${theme.palette.secondary.dark}`,
                      borderRadius: 1.5,
                    }}
                  >
                    <QuantityTransferredIcon />
                  </Box>
                  <Typography sx={{ paddingTop: 1.8 }} ml={2}>
                    Quantity Transfered
                  </Typography>
                </Box>
                <Box sx={{ paddingTop: 1.2 }}>
                  <Chip
                    sx={{
                      minWidth: "70px",
                      color: "blue",
                      borderRadius: 1,
                    }}
                    label={
                      state?.vaccines?.size -
                        state?.vaccines?.available_quantity || 0
                    }
                  />
                </Box>
              </Grid>
              {/* 3rd Row */}
              <Grid
                container
                display={"flex"}
                justifyContent={"space-between"}
                alignItems={"center"}
                sx={{ mb: 1.5 }}
              >
                <Box display={"flex"} alignItems={"center"}>
                  <Box
                    height={"60px"}
                    width={"60px"}
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"center"}
                    sx={{
                      backgroundColor: `${theme.palette.secondary.dark}`,
                      borderRadius: 1.5,
                    }}
                  >
                    <TempratureIcon />
                  </Box>
                  <Box>
                    <Typography
                      variant="body1"
                      component="div"
                      ml={2}
                      sx={{ paddingTop: 1 }}
                    >
                      {/* {propsData?.type && propsData?.type === "sent"
                      ? "Requested To"
                      : "Requested By"} */}
                      Storage Temperature
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ paddingTop: 1.2 }}>
                  <Chip
                    sx={{
                      minWidth: "70px",
                      color: "blue",
                      borderRadius: 1,
                    }}
                    // label={
                    //   propsData?.type && propsData?.type === "sent"
                    //     ? propsData?.request_data?.receiver_name
                    //     : propsData?.request_data?.sender_name
                    // }
                    label={state?.vaccines?.previous_temperature}
                  />
                </Box>
              </Grid>
              {/* 4th Row */}
              <Grid
                container
                display={"flex"}
                justifyContent={"space-between"}
                alignItems={"center"}
                sx={{ mb: 1.5 }}
              >
                <Box display={"flex"} alignItems={"center"}>
                  <Box
                    height={"60px"}
                    width={"60px"}
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"center"}
                    sx={{
                      backgroundColor: `${theme.palette.secondary.dark}`,
                      borderRadius: 1.5,
                    }}
                  >
                    <BatchIcon1 />
                  </Box>{" "}
                  <Box>
                    <Typography
                      variant="body1"
                      component="div"
                      ml={2}
                      sx={{ paddingTop: 1 }}
                    >
                      Transfer Date
                    </Typography>
                  </Box>
                </Box>
                <Box
                  sx={{
                    paddingTop: 1.2,
                  }}
                >
                  <Chip
                    label={
                      state?.vaccines?.transfer_date
                        ? format(
                            new Date(state?.vaccines?.transfer_date),
                            "MM/dd/yyyy"
                          )
                        : ""
                    }
                    sx={{ color: "blue", minWidth: "70px", borderRadius: 1 }}
                  />
                </Box>
              </Grid>

              {/* 5th Row  */}

              <Grid
                container
                display={"flex"}
                justifyContent={"space-between"}
                alignItems={"center"}
                sx={{ mb: 1.5 }}
              >
                <Box display={"flex"} alignItems={"center"}>
                  <Box
                    height={"60px"}
                    width={"60px"}
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"center"}
                    sx={{
                      backgroundColor: `${theme.palette.secondary.dark}`,
                      borderRadius: 1.5,
                    }}
                  >
                    <ExpiredDosesIcon />
                  </Box>{" "}
                  <Box>
                    <Typography
                      variant="body1"
                      component="div"
                      ml={2}
                      sx={{ paddingTop: 1 }}
                    >
                      Batch Expiry
                    </Typography>
                  </Box>
                </Box>
                <Box
                  sx={{
                    paddingTop: 1.2,
                  }}
                >
                  <Chip
                    label={
                      state?.vaccines?.expiry_date
                        ? format(
                            new Date(state?.vaccines?.expiry_date),
                            "MM/dd/yyyy"
                          )
                        : ""
                    }
                    sx={{ color: "blue", minWidth: "70px", borderRadius: 1 }}
                  />
                </Box>
              </Grid>

              {/* 6th Row  */}

              <Grid
                container
                display={"flex"}
                justifyContent={"space-between"}
                alignItems={"center"}
                sx={{ mb: 1.5 }}
              >
                <Box display={"flex"} alignItems={"center"}>
                  <Box
                    height={"60px"}
                    width={"60px"}
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"center"}
                    sx={{
                      backgroundColor: `${theme.palette.secondary.dark}`,
                      borderRadius: 1.5,
                    }}
                  >
                    <WastedDosesIcon />
                  </Box>{" "}
                  <Box>
                    <Typography
                      variant="body1"
                      component="div"
                      ml={2}
                      sx={{ paddingTop: 1 }}
                    >
                      Units Wasted
                    </Typography>
                  </Box>
                </Box>
                <Box
                  sx={{
                    paddingTop: 1.2,
                  }}
                >
                  <Chip
                    label={state?.vaccines?.units_wasted || 0}
                    sx={{ color: "blue", minWidth: "70px", borderRadius: 1 }}
                  />
                </Box>
              </Grid>
            </Box>
          </Paper>
        </Grid>
        <Grid item spacing={2} xs={12} sm={12} md={6} lg={6} xl={6}>
          <Paper
            className={classes?.list}
            // sx={{ height: "532px", overflowY: "scroll" }}
          >
            <Box padding={2}>
              {" "}
              <Typography variant="h6" component="div">
                Transfer History
              </Typography>
              <Typography sx={{ mb: 1.5 }} color="text.secondary">
                {"Batch# " + state?.vaccines?.reference_number}
              </Typography>
              {state?.vaccines?.sub_batches.length > 0 ? (
                state?.vaccines?.sub_batches.map((row, index) => (
                  <Box>
                    <Box>
                      <Stack direction={"row"} gap={2}>
                        <Box
                          display={"flex"}
                          justifyContent={"center"}
                          flexDirection={"column"}
                        >
                          <RedCircle />
                        </Box>
                        <Typography variant="h6">{row?.sender_name}</Typography>

                        <Box
                          display={"flex"}
                          justifyContent={"center"}
                          flexDirection={"column"}
                        >
                          <ArrowIcon />
                        </Box>
                        <Typography variant="h6">
                          {row?.receiver_name}
                        </Typography>
                      </Stack>
                      {/* 1st row */}
                      <Grid
                        container
                        display={"flex"}
                        justifyContent={"space-between"}
                        alignItems={"center"}
                        sx={{ mb: 0.5, px: 2.5 }}
                      >
                        <Typography
                          variant="body1"
                          component="div"
                          ml={2}
                          color="text.secondary"
                        >
                          Transfer Date
                        </Typography>
                        <Box>
                          <Chip
                            label={
                              row?.transfer_date
                                ? format(
                                    new Date(row?.transfer_date),
                                    "MM/dd/yyyy"
                                  )
                                : ""
                            }
                            sx={{
                              color: "blue",
                              minWidth: "70px",
                              borderRadius: 1,
                            }}
                          />
                        </Box>
                      </Grid>
                      {/* 2nd row */}
                      <Grid
                        container
                        display={"flex"}
                        justifyContent={"space-between"}
                        alignItems={"center"}
                        sx={{ mb: 0.5, px: 2.5 }}
                      >
                        <Typography
                          variant="body1"
                          color="text.secondary"
                          component="div"
                          ml={2}
                        >
                          Batch Quantity
                        </Typography>
                        <Box>
                          <Chip
                            label={row?.size}
                            sx={{
                              color: "blue",
                              minWidth: "70px",
                              borderRadius: 1,
                            }}
                          />
                        </Box>
                      </Grid>
                      {/* 3rd row */}
                      <Grid
                        container
                        display={"flex"}
                        justifyContent={"space-between"}
                        alignItems={"center"}
                        sx={{ mb: 0.5, px: 2.5 }}
                      >
                        <Typography
                          variant="body1"
                          color="text.secondary"
                          component="div"
                          ml={2}
                        >
                          Storage Temperature
                        </Typography>
                        <Box>
                          <Chip
                            label={
                              row?.storage_temprature?.replace("_", " ") ||
                              "N/A"
                            }
                            sx={{
                              color: "blue",
                              minWidth: "70px",
                              borderRadius: 1,
                            }}
                          />
                        </Box>
                      </Grid>
                      {/* 4th row */}
                      <Grid
                        container
                        display={"flex"}
                        justifyContent={"space-between"}
                        alignItems={"center"}
                        sx={{ mb: 0.5, px: 2.5 }}
                      >
                        <Typography
                          variant="body1"
                          color="text.secondary"
                          component="div"
                          ml={2}
                        >
                          Batch Expiry
                        </Typography>
                        <Box>
                          <Chip
                            label={
                              row?.expiry_date
                                ? format(
                                    new Date(row?.expiry_date),
                                    "MM/dd/yyyy"
                                  )
                                : "" || "N/A"
                            }
                            sx={{
                              color: "blue",
                              minWidth: "70px",
                              borderRadius: 1,
                            }}
                          />
                        </Box>
                      </Grid>
                    </Box>
                  </Box>
                ))
              ) : (
                <Box
                  display={"flex"}
                  flexDirection={"column"}
                  justifyContent={"center"}
                  mt={"40%"}
                >
                  {" "}
                  <Typography textAlign={"center"}>
                    No Transfer History for This Batch.
                  </Typography>{" "}
                </Box>
              )}
            </Box>
          </Paper>
        </Grid>
      </Grid>
      <Paper elevation={1} sx={{ marginTop: 5, paddingX: 3, paddingTop: 5 }}>
        <Box>
          <Typography
            variant="h5"
            sx={{ color: theme.palette.text.light, fontWeight: "bold" }}
          >
            {" "}
            Batch Details{" "}
          </Typography>
        </Box>
        <Box display={"flex"} flexDirection={"row"} gap={2}>
          <Box display={"flex"} flexDirection={"row"} gap={1}>
            <Box
              display={"flex"}
              justifyContent={"center"}
              flexDirection={"column"}
            >
              <RectangleMinistry />
            </Box>
            <Typography>Ministry</Typography>
          </Box>
          <Box display={"flex"} flexDirection={"row"} gap={1}>
            <Box
              display={"flex"}
              justifyContent={"center"}
              flexDirection={"column"}
            >
              <RectangleProvince />
            </Box>{" "}
            <Typography>Province</Typography>
          </Box>
          <Box display={"flex"} flexDirection={"row"} gap={1}>
            <Box
              display={"flex"}
              justifyContent={"center"}
              flexDirection={"column"}
            >
              <RectangleDistrict />
            </Box>{" "}
            <Typography>District</Typography>
          </Box>
          <Box display={"flex"} flexDirection={"row"} gap={1}>
            <Box
              display={"flex"}
              justifyContent={"center"}
              flexDirection={"column"}
            >
              <RectangleClinic />
            </Box>{" "}
            <Typography>Clinic</Typography>
          </Box>
        </Box>
        <TableContainer>
          <Table sx={{ marginTop: 3 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                {headings?.map((h, index) => (
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                    }}
                    align="center"
                    key={`${index}-table-heading-${h}`}
                  >
                    <Chip
                      label={h}
                      sx={{
                        backgroundColor: theme.palette.secondary.dark,
                        borderRadius: 1,
                        color: theme.palette.primary.main,
                      }}
                    ></Chip>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {state?.vaccines?.last_6_transactions?.map((row, index) => (
                <TableRow key={`${index}-row.name-${index + 21}`}>
                  <TableCell align="center">{row?.reference_number}</TableCell>
                  <TableCell>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: row,
                        minWidth: "120px",
                        gap: 0.5,
                        justifyContent: "center",
                      }}
                    >
                      <Box
                        display={"flex"}
                        justifyContent={"center"}
                        flexDirection={"column"}
                      >
                        {row?.sender_role === "ministry" ? (
                          <RectangleMinistry />
                        ) : row?.senderRole === "state" ? (
                          <RectangleProvince />
                        ) : row?.sender_role === "district" ? (
                          <RectangleDistrict />
                        ) : row?.sender_role === "hospital" ? (
                          <RectangleClinic />
                        ) : null}
                      </Box>
                      {row?.sender_name || "---"}
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: row,
                        minWidth: "120px",
                        gap: 0.5,
                        justifyContent: "center",
                      }}
                    >
                      <Box
                        display={"flex"}
                        justifyContent={"center"}
                        flexDirection={"column"}
                      >
                        {row?.receiver_role === "ministry" ? (
                          <RectangleMinistry />
                        ) : row?.receiverRole === "state" ? (
                          <RectangleProvince />
                        ) : row?.receiver_role === "district" ? (
                          <RectangleDistrict />
                        ) : row?.receiver_role === "hospital" ? (
                          <RectangleClinic />
                        ) : null}
                      </Box>
                      {row?.receiver_name || "---"}
                    </Box>
                  </TableCell>
                  <TableCell align="center">{row?.quantity}</TableCell>
                  <TableCell align="center">{row?.main_type}</TableCell>
                  <TableCell align="center">
                    {" "}
                    <Chip
                      label={row?.transaction_type}
                      sx={{
                        backgroundColor:
                          row?.transaction_type === "issue" ||
                          row?.transaction_type === "used" ||
                          row?.transaction_type === "transfer"
                            ? "#00C851"
                            : row?.transaction_type === "expired"
                            ? "#FFBB33"
                            : "#FF4444",
                        borderRadius: 2,
                        minWidth: "80px",
                        color: theme?.palette?.text?.white,
                      }}
                    />
                  </TableCell>
                  <TableCell align="center">
                    {row?.expiry_date
                      ? format(new Date(row?.expiry_date), "MM/dd/yyyy")
                      : ""}
                  </TableCell>
                  <TableCell align="center">
                    {row?.storage_temprature.replace("_", " ")}
                  </TableCell>
                  <TableCell align="center">
                    {row?.transaction_date
                      ? format(new Date(row?.transaction_date), "MM/dd/yyyy")
                      : ""}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Box display={"flex"} justifyContent={"center"}>
          <Button onClick={transactionTable}>See more</Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default BatchDetails;
